export default "__VITE_ASSET__DPvWP1Nr__"